import React from "react";
import Card from "components/card";

const ThemedSummaryCard = ({
  title,
  count = 0,
  description,
  icon,
  badgeText,
  badgeIcon,
  theme,
}) => {
  return (
    <Card className={`summary-card ${theme}`}>
      
      <div className="flex items-center justify-between px-6 pt-6 pb-2">
        <h4 className="text-[13px] uppercase tracking-wide text-slate-700 leading-tight">
          {title}
        </h4>

        {icon && (
          <div className="icon-bg p-2 rounded-lg">
            {React.cloneElement(icon, { className: `icon-color w-4 h-4 ${icon.props.className || ""}` })}
          </div>
        )}
      </div>

      <div className="px-6 pb-6">
        <div className="flex items-baseline gap-2">
          <span className="text-[32px] font-semibold leading-none">
            {count}
          </span>

          {badgeText && (
            <span className="badge">
              {badgeIcon && React.cloneElement(badgeIcon, { className: "w-3 h-3 mr-1" })}
              {badgeText}
            </span>
          )}
        </div>

        {description && (
          <p className="text-[12px] text-slate-700 mt-2 leading-tight">
            {description}
          </p>
        )}
      </div>
    </Card>
  );
};

export default ThemedSummaryCard;
